export default __webpack_public_path__ + "static/media/04__o_4.56c43562.jpg";